<!--
 * @Author: weiyong
 * @Description: Multi-language switching component
-->
<template>
  <Dropdown
    v-if="moreLangFlag"
    placement="bottom"
    :trigger="['click','hover']"
    :dropMenuList="localeList"
    :selectedKeys="selectedKeys"
    @menu-event="handleMenuEvent"
    overlayClassName="app-locale-picker-overlay"
  >
    <span class="cursor-pointer flex items-center">
      <Icon icon="ion:language"/>
      <span v-if="showText" class="ml-1">{{ t(getLocaleText) }}</span>
    </span>
  </Dropdown>
</template>
<script lang="ts" setup>
import type {LocaleType} from '/#/config';
import type {DropMenu} from '@/components/Dropdown';
import {ref, watchEffect, unref, computed} from 'vue';
import {Dropdown} from '@/components/Dropdown';
import {Icon} from '@/components/Icon';
import {useLocale} from '@/i18n/useLocale';
import {useI18n} from "vue-i18n";
import {LOCALE} from "@/settings/localeSetting";
import {useGlobSetting} from "@/hooks/setting";


const { t } = useI18n();

// locale list
const localeList: DropMenu[] = [
  {
    text: t('简体中文'),
    event: LOCALE.ZH_CN,
  },
  {
    text: t('English'),
    event: LOCALE.EN_US,
  },
];

const props = defineProps({
  /**
   * Whether to display text
   */
  showText: {type: Boolean, default: true},
  /**
   * Whether to refresh the interface when changing
   */
  reload: {type: Boolean},
});
const { moreLangFlag } = useGlobSetting({});
const selectedKeys = ref<string[]>([]);

const {changeLocale, getLocale} = useLocale();

const getLocaleText = computed(() => {
  const key = selectedKeys.value[0];
  if (!key) {
    return '';
  }
  return t('测试');
});

watchEffect(() => {
  selectedKeys.value = [unref(getLocale)];
});

async function toggleLocale(lang: LocaleType | string) {
  await changeLocale(lang as LocaleType);
  selectedKeys.value = [lang as string];

  if(lang==='en'){
    lang='en-US';
  }
  if(lang==='zh'||lang==='zh_CN'){
    lang='zh-CN';
  }
  let hrefUrl = location.href;
  if(hrefUrl.indexOf("projectI18n=zh-CN")>0){
    hrefUrl = hrefUrl.replace("projectI18n=zh-CN",`projectI18n=${lang}`);
  }else if(hrefUrl.indexOf("projectI18n=en-US")>0){
    hrefUrl = hrefUrl.replace("projectI18n=en-US",`projectI18n=${lang}`);
  }
  if (props.reload) {
    window.location.href = hrefUrl;
  }
  ;
}

function handleMenuEvent(menu: DropMenu) {
  if (unref(getLocale) === menu.event) {
    return;
  }
  toggleLocale(menu.event as string);
}
</script>

<style lang="less">
.app-locale-picker-overlay {
  .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
</style>
